// board[position] = piece; a piece's number is its home position, so the solved board is [0..15].
export const SIZE = 4;
export const EMPTY = SIZE * SIZE - 1;

const SOLVED = Array.from({ length: SIZE * SIZE }, (_, i) => i);

function neighbours(pos: number) {
  const row = Math.floor(pos / SIZE);
  const col = pos % SIZE;
  return [
    row > 0 && pos - SIZE,
    row < SIZE - 1 && pos + SIZE,
    col > 0 && pos - 1,
    col < SIZE - 1 && pos + 1,
  ].filter((p): p is number => p !== false);
}

export const isSolved = (board: number[]) => board.every((piece, pos) => piece === pos);

export const canMove = (board: number[], pos: number) =>
  neighbours(board.indexOf(EMPTY)).includes(pos);

export function move(board: number[], pos: number) {
  const next = [...board];
  const empty = next.indexOf(EMPTY);
  [next[pos], next[empty]] = [next[empty], next[pos]];
  return next;
}

// The tile a swipe pushes: the empty slot's neighbour on the side the swipe comes from
// (swipe right → the tile left of the empty slot). May be off-board/wrapped; canMove rejects it.
export function swipeTarget(board: number[], dx: number, dy: number) {
  const step = Math.abs(dx) > Math.abs(dy) ? Math.sign(dx) : Math.sign(dy) * SIZE;
  return board.indexOf(EMPTY) - step;
}

// Random legal slides from the solved board, so the result is always solvable.
// Never undoing the previous slide keeps `moves` close to the real difficulty.
export function shuffle(moves: number, random = Math.random) {
  let board = SOLVED;
  while (isSolved(board)) {
    board = SOLVED;
    let empty = EMPTY;
    let previous = -1;
    for (let i = 0; i < moves; i++) {
      const undo = previous;
      const options = neighbours(empty).filter((p) => p !== undo);
      const target = options[Math.floor(random() * options.length)];
      board = move(board, target);
      previous = empty;
      empty = target;
    }
  }
  return board;
}
